import { create } from "zustand";
import { persist } from "zustand/middleware";

const useWorkshopProgressStore = create(
  persist(
    (set) => ({
      progress: {},
      setProgress: (workshopId, data) => set((state) => ({ progress: { ...state.progress, [workshopId]: data } })),
    }),
    { name: "workshop-progress" }
  )
);

export default useWorkshopProgressStore;
